import { PermissionScope_enum } from '../../../../graphql/hasura/generated';

import type { IScopeQueryFilters, IUseScopeQueriesArgs } from './typings';

export function getScopeQueryFilters(args: IUseScopeQueriesArgs): IScopeQueryFilters {
  const { permissionScope, scopedIds } = args;

  if (!scopedIds.length) {
    return {}; // No filters
  }

  const filters: IScopeQueryFilters = {};

  if (permissionScope === PermissionScope_enum.ORGANIZATION) {
    filters.organizationFilter = {
      organizationId: { _in: scopedIds },
    };
  } else if (permissionScope === PermissionScope_enum.PROPERTY) {
    filters.organizationFilter = {
      properties: {
        propertyId: { _in: scopedIds },
      },
    };

    filters.propertyFilter = {
      propertyId: { _in: scopedIds },
    };
  } else if (permissionScope === PermissionScope_enum.UNIT) {
    filters.organizationFilter = {
      properties: {
        units: {
          unitId: { _in: scopedIds },
        },
      },
    };

    filters.unitFilter = {
      unitId: { _in: scopedIds },
    };
  } else if (permissionScope === PermissionScope_enum.ACCESS_POINT) {
    filters.organizationFilter = {
      properties: {
        accessPoints: {
          accessPointId: { _in: scopedIds },
        },
      },
    };

    filters.accessPointFilter = {
      accessPointId: { _in: scopedIds },
    };
  }

  return filters;
}
